import { render } from "./Identity.vue?vue&type=template&id=217a1962&scoped=true"
import script from "./Identity.vue?vue&type=script&lang=js"
export * from "./Identity.vue?vue&type=script&lang=js"

import "./Identity.vue?vue&type=style&index=0&id=217a1962&scoped=true&lang=css"

import exportComponent from "E:\\Proj\\Apps\\Stock\\vuestock\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-217a1962"]])

export default __exports__